import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import "./SearchAppearancesCard.css"; // <--- Import your scoped CSS here

export default function SearchAppearancesCard() {
  const keywords = ["retail", "Sales", "Business Development", "site core developer", "medical representative"];

  // Mock data for the 90 days line chart trend
  const chartData = [
    { name: "Wk 1", appearances: 5 },
    { name: "Wk 2", appearances: 12 },
    { name: "Wk 3", appearances: 8 },
    { name: "Wk 4", appearances: 22 },
    { name: "Wk 5", appearances: 18 },
    { name: "Wk 6", appearances: 35 },
    { name: "Wk 7", appearances: 44 },
  ];

  // Custom tool-tip component for Recharts
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-chart-tooltip">
          <p className="m-0 fw-bold">{`${payload[0].value} views`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    /* Scoped Parent Class added here */
    <Card className="score-card search-appearances-card">
      <Card.Body className="score-card__body">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h4 className="fw-bold m-0">
            44 <span className="fs-6 fw-normal text-dark">Search appearance in last</span>
          </h4>
          <select className="form-select dropdown-select py-1 px-2 border-0 fw-semibold text-primary" style={{ width: "auto" }}>
            <option>90 days</option>
          </select>
        </div>
        
        <div className="text-success small fw-semibold mb-4">
          <FontAwesomeIcon icon={faArrowUp} className="me-1" /> 500% <span className="text-muted fw-normal">since last week</span>
        </div>

        <h6 className="fw-bold small mb-3">Your profile appeared in these searches most frequently</h6>
        
        <Row className="align-items-center">
          <Col md={6}>
            <div className="search-keywords d-flex flex-column gap-2">
              {keywords.map((keyword, idx) => (
                <div key={idx} className="d-flex align-items-center justify-content-between py-1 border-bottom">
                  <span className="small text-secondary text-truncate me-2">{keyword}</span>
                  <Badge bg="light" className="text-muted border-0 bg-secondary-subtle">4 times</Badge>
                </div>
              ))}
            </div>
          </Col>
          
          <Col md={6}>
            {/* Embedded Responsive Line Chart */}
            <div className="graph-container p-2 bg-light rounded mt-3 mt-md-0" style={{ height: "180px", width: "100%" }}>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={chartData} margin={{ top: 10, right: 10, left: -25, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                  <XAxis 
                    dataKey="name" 
                    tick={{ fontSize: 10, fill: '#6c757d' }} 
                    axisLine={false}
                    tickLine={false}
                  />
                  <YAxis 
                    tick={{ fontSize: 10, fill: '#6c757d' }} 
                    axisLine={false}
                    tickLine={false}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Line 
                    type="monotone" 
                    dataKey="appearances" 
                    stroke="#0d6efd" /* standard bootstrap primary color */
                    strokeWidth={2.5}
                    dot={{ r: 4, strokeWidth: 2 }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}